module.exports = __webpack_public_path__ + "static/logo-footer-cb16dfe03d7d4dda20589eb3509793d6.png";